export default {
  data() {
    return {
      needConfirm: true, // 默认需要确认
    }
  },
  methods: {
    onCloseConfirm(afterConfirm, msg) {
      if (!this.needConfirm) {
        afterConfirm && afterConfirm()
        return
      }
      const defaultMsg = '关闭后已填数据将被清空，是否继续？'
      this.$confirm({
        title: msg || defaultMsg,
        okText: '确认',
        cancelText: '取消',
        onOk: () => {
          afterConfirm && afterConfirm()
          this.reset && this.reset()
        },
        onCancel() {},
      })
    },
  },
}
